import type { HTMLAttributes } from 'react';

export const CellContent = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div className={['m-0', className].filter(Boolean).join(' ')} {...props} />
);
